export default "__VITE_ASSET__CL496yI5__"